import { render } from "./ActivatePopup.vue?vue&type=template&id=64f4dda0&scoped=true&ts=true"
import script from "./ActivatePopup.vue?vue&type=script&lang=ts"
export * from "./ActivatePopup.vue?vue&type=script&lang=ts"

import "./ActivatePopup.vue?vue&type=style&index=0&id=64f4dda0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f4dda0"]])

export default __exports__